export const GET_CLASS_REQUEST = 'GET_CLASS_REQUEST';
export const GET_CLASS_SUCCESS = 'GET_CLASS_SUCCESS';
export const GET_CLASS_FAILURE = 'GET_CLASS_FAILURE';

export const getClassByClassroomId = (productId, classroomId) =>
    ({ type: GET_CLASS_REQUEST, productId, classroomId, isLoadingEditClassDetail: true });

export const getClassSuccess = ({ data }) =>
    ({ type: GET_CLASS_SUCCESS, data, isLoadingEditClassDetail: false });

export const getClassFailure = () =>
    ({ type: GET_CLASS_FAILURE, isLoadingEditStudentDetail: false });

export const RENAME_GROUP_REQUEST = 'RENAME_GROUP_REQUEST';
export const RENAME_GROUP_SUCCESS = 'RENAME_GROUP_SUCCESS';
export const RENAME_GROUP_FAILURE = 'RENAME_GROUP_FAILURE';

export const renameClassroomGroup = (classroomId, groupId, newGroupName) =>
    ({ type: RENAME_GROUP_REQUEST, classroomId, groupId, newGroupName, isRenameGroupInProgress: true });

export const renameClassroomGroupSuccess = () =>
    ({
        type: RENAME_GROUP_SUCCESS,
        showRenameGroupConfirmationModal: true,
        showRenameGroupConfirmationBeforeSubmit: false,
        isRenameGroupInProgress: false
    });

export const renameClassroomGroupFailure = () =>
    ({
        type: RENAME_GROUP_FAILURE,
        isRenameGroupInProgress: false,
        showRenameGroupConfirmationBeforeSubmit: false
    });

export const DOWNLOAD_STUDENT_SIGN_IN_CARDS_REQUEST = 'DOWNLOAD_STUDENT_SIGN_IN_CARDS_REQUEST';
export const DOWNLOAD_STUDENT_SIGN_IN_CARDS_SUCCESS = 'DOWNLOAD_STUDENT_SIGN_IN_CARDS_SUCCESS';
export const DOWNLOAD_STUDENT_SIGN_IN_CARDS_FAILURE = 'DOWNLOAD_STUDENT_SIGN_IN_CARDS_FAILURE';

export const downloadStudentSignInCardsRequest = (productId, classroomId, SignInCardPageSizeType) =>
    ({ type: DOWNLOAD_STUDENT_SIGN_IN_CARDS_REQUEST, productId, classroomId, SignInCardPageSizeType, isDownloadingSignInCards: true });

export const downloadStudentSignInCardsSuccess = (downloadUrl) => {
    window.location.href = downloadUrl;
    return ({ type: DOWNLOAD_STUDENT_SIGN_IN_CARDS_SUCCESS, isDownloadingSignInCards: false });
};

export const downloadStudentSignInCardsFailure = () =>
    ({ type: DOWNLOAD_STUDENT_SIGN_IN_CARDS_FAILURE, isDownloadingSignInCards: false });

export const SHOW_EDIT_CLASS_GROUP = 'SHOW_EDIT_CLASS_GROUP';
export const HIDE_EDIT_CLASS_GROUP = 'HIDE_EDIT_CLASS_GROUP';

export const showEditClassGroup = selectedGroup => ({ type: SHOW_EDIT_CLASS_GROUP, selectedGroup });
export const hideEditClassGroup = () => ({ type: HIDE_EDIT_CLASS_GROUP });

export const SHOW_RENAME_GROUP_MODAL = 'SHOW_RENAME_GROUP_MODAL';
export const HIDE_RENAME_GROUP_MODAL = 'HIDE_RENAME_GROUP_MODAL';

export const showRenameGroup = () => ({ type: SHOW_RENAME_GROUP_MODAL, showRenameGroupModal: true });
export const hideRenameGroup = () => ({ type: HIDE_RENAME_GROUP_MODAL, showRenameGroupModal: false });

export const OPEN_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT = 'OPEN_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT';
export const CLOSE_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT = 'CLOSE_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT';

export const openRenameGroupConfirmationBeforeSubmit = () =>
    ({
        type: OPEN_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT,
        showRenameGroupConfirmationBeforeSubmit: true,
        refreshEditClass: false
    });

export const closeRenameGroupConfirmationBeforeSubmit = () =>
    ({
        type: CLOSE_RENAME_GROUP_CONFIRMATION_BEFORE_SUBMIT,
        showRenameGroupConfirmationBeforeSubmit: false
    });

export const CLOSE_RENAME_GROUP_CONFIRMATION = 'CLOSE_RENAME_GROUP_CONFIRMATION';
export const closeRenameGroupConfirmation = () =>
    ({
        type: CLOSE_RENAME_GROUP_CONFIRMATION,
        showRenameGroupConfirmationModal: false,
        showRenameGroupModal: false,
        editClassGroupIsVisible: false,
        refreshEditClass: true,
        selectedGroup: null
    });

export const MODIFIED_CLASS_SAVE_REQUEST = 'MODIFIED_CLASS_SAVE_REQUEST';
export const MODIFIED_CLASS_SAVE_SUCCESS = 'MODIFIED_CLASS_SAVE_SUCCESS';
export const MODIFIED_CLASS_SAVE_FAILURE = 'MODIFIED_CLASS_SAVE_FAILURE';

export const saveModifiedClass = (classroomId, newClassroomName, newYearGroup) =>
    ({
        type: MODIFIED_CLASS_SAVE_REQUEST,
        classroomId,
        newClassroomName,
        newYearGroup,
        isSavingClass: true,
        isUpdateSuccessful: false
    });

export const saveModifiedClassSuccess = () => ({
    type: MODIFIED_CLASS_SAVE_SUCCESS,
    isSavingClass: false,
    isUpdateSuccessful: true
});

export const saveModifiedClassFailure = editClassValidationMessage => ({
    type: MODIFIED_CLASS_SAVE_FAILURE,
    editClassValidationMessage,
    isUpdateSuccessful: false,
    isSavingClass: false
});

export const CLOSE_CLASS_VALIDATION_MODAL = 'CLOSE_CLASS_VALIDATION_MODAL';

export const handleOnCloseValidationModal = () => ({
    type: CLOSE_CLASS_VALIDATION_MODAL,
    isUpdateSuccessful: true
});

export const DOWNLOAD_TEACHER_SIGN_IN_CARD_REQUEST = 'DOWNLOAD_TEACHER_SIGN_IN_CARD_REQUEST';
export const DOWNLOAD_TEACHER_SIGN_IN_CARD_SUCCESS = 'DOWNLOAD_TEACHER_SIGN_IN_CARD_SUCCESS';
export const DOWNLOAD_TEACHER_SIGN_IN_CARD_FAILURE = 'DOWNLOAD_TEACHER_SIGN_IN_CARD_FAILURE';

export const printTeacherSignInCard = (selectedProductId, teacherId) =>
    ({ type: DOWNLOAD_TEACHER_SIGN_IN_CARD_REQUEST, isSignInCardDownloaded: false, teacherId, selectedProductId });

export const printTeacherSignInCardSuccess = (downloadUrl, isSignInCardDownloaded) => {
    window.location.href = downloadUrl;
    return ({ type: DOWNLOAD_TEACHER_SIGN_IN_CARD_SUCCESS, downloadUrl, isSignInCardDownloaded });
};

export const printTeacherSignInCardFailure = isSignInCardDownloaded =>
    ({ type: DOWNLOAD_TEACHER_SIGN_IN_CARD_FAILURE, isSignInCardDownloaded });

export const OPEN_UNASSIGN_TEACHERS_MODAL = 'OPEN_UNASSIGN_TEACHERS_MODAL';
export const CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL = 'CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL';

export const openUnAssignTeachersModal = () =>
    ({ type: OPEN_UNASSIGN_TEACHERS_MODAL, isUserOperationModalOpen: true });

export const closeTeachersOperationConfirmationModal = () =>
    ({ type: CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL, deleteSuccess: false, refreshTeacherList: true, selectedTeachers: [], notDeletedTeachers: [] });

export const UNASSIGN_TEACHER_REQUEST = 'UNASSIGN_TEACHER_REQUEST';
export const UNASSIGN_TEACHER_SUCCESS = 'UNASSIGN_TEACHER_SUCCESS';
export const UNASSIGN_TEACHER_FAILURE = 'UNASSIGN_TEACHER_FAILURE';

export const unassignTeachers = (classroomId, selectedTeachers, productId) =>
    ({ type: UNASSIGN_TEACHER_REQUEST, classroomId, selectedTeachers, productId, disableConfirmationButtons: true });

export const unassignTeachersSuccess = () =>
    ({ type: UNASSIGN_TEACHER_SUCCESS, isUserOperationModalOpen: false, disableConfirmationButtons: false });

export const unassignTeachersFailure = () =>
    ({ type: UNASSIGN_TEACHER_FAILURE, disableConfirmationButtons: false });

export const PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_REQUEST = 'PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_REQUEST';
export const PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_SUCCESS = 'PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_SUCCESS';
export const PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_FAILURE = 'PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_FAILURE';

export function printClassroomTeacherSignInCard(teacherId, productId, downloadingTeachersIds, format) {
    return { type: PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_REQUEST, teacherId, productId, downloadingTeachersIds, format };
}

export const printClassroomTeacherSignInCardSuccess = (teacherId, downloadUrl, downloadingTeachersIds) => {
    window.location.href = downloadUrl;
    downloadingTeachersIds.delete(teacherId);
    return ({ type: PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_SUCCESS, teacherId, downloadUrl, downloadingTeachersIds });
};

export const printClassroomTeacherSignInCardFailure = (teacherId, downloadingTeachersIds) => {
    downloadingTeachersIds.delete(teacherId);
    return ({ type: PRINT_CLASSROOM_TEACHERS_SIGN_IN_CARD_FAILURE, teacherId, downloadingTeachersIds });
};

export const DELETE_GROUP_REQUEST = 'DELETE_GROUP_REQUEST';
export const DELETE_GROUP_SUCCESS = 'DELETE_GROUP_SUCCESS';
export const DELETE_GROUP_FAILURE = 'DELETE_GROUP_FAILURE';

export const deleteGroup = (classroomId, groupId) =>
    ({ type: DELETE_GROUP_REQUEST, classroomId, groupId, isDeletingGroupInProgress: true, refreshEditClass: false });

export const deleteGroupSuccess = () =>
    ({
        type: DELETE_GROUP_SUCCESS,
        isDeletingGroupInProgress: false,
        showDeleteGroupConfirmationBeforeSubmit: false,
        showDeleteGroupConfirmation: true
    });

export const deleteGroupFailure = () =>
    ({
        type: DELETE_GROUP_FAILURE,
        isDeletingGroupInProgress: false,
        refreshEditClass: false,
        showDeleteGroupConfirmationBeforeSubmit: false
    });

export const OPEN_DELETE_NON_EMPTY_GROUP_CONFIRMATION = 'OPEN_DELETE_NON_EMPTY_GROUP_CONFIRMATION';
export const CLOSE_DELETE_NON_EMPTY_GROUP_CONFIRMATION = 'CLOSE_DELETE_NON_EMPTY_GROUP_CONFIRMATION';

export const openDeleteNonEmptyGroupConfirmation = () =>
    ({
        type: OPEN_DELETE_NON_EMPTY_GROUP_CONFIRMATION,
        showDeleteNonEmptyGroupConfirmationModal: true
    });

export const closeDeleteNonEmptyGroupConfirmation = () =>
    ({
        type: CLOSE_DELETE_NON_EMPTY_GROUP_CONFIRMATION,
        showDeleteNonEmptyGroupConfirmationModal: false
    });

export const CLOSE_DELETE_GROUP_CONFIRMATION = 'CLOSE_DELETE_GROUP_CONFIRMATION';

export const closeDeleteGroupConfirmation = () =>
    ({
        type: CLOSE_DELETE_GROUP_CONFIRMATION,
        refreshEditClass: true,
        editClassGroupIsVisible: false,
        showDeleteGroupConfirmation: false
    });

export const OPEN_CHANGE_COURSE = 'OPEN_CHANGE_COURSE';
export const CLOSE_CHANGE_COURSE = 'CLOSE_CHANGE_COURSE';
export const BACK_TO_CHANGE_COURSE = 'BACK_TO_CHANGE_COURSE';

export function openChangeCourse(classroomId, groupId) {
    return { type: OPEN_CHANGE_COURSE, classroomId, groupId };
}

export function closeChangeCourse() {
    return { type: CLOSE_CHANGE_COURSE };
}

export function backToChangeCourse() {
    return { type: BACK_TO_CHANGE_COURSE };
}

export const CHANGE_COURSE_REQUEST = 'CHANGE_COURSE_REQUEST';
export const CHANGE_COURSE_SUCCESS = 'CHANGE_COURSE_SUCCESS';
export const CHANGE_COURSE_FAILURE = 'CHANGE_COURSE_FAILURE';

export const CARRY_OVER_TASK_TYPE = 'CarryOver';
export const CANCEL_TASK_TYPE = 'CancelTask';

export const changeCourse = ({
    classroomId, groupId, courseId, submittedFields, upfCourseId = '0', newCourseId, useUpfSchoolDefault
}) => ({
    type: CHANGE_COURSE_REQUEST,
    classroomId,
    groupId,
    courseId,
    submittedFields,
    upfCourseId,
    newCourseId,
    useUpfSchoolDefault
});

export const changeCourseSuccess = (classroomId, groupId, assignedCourseId, submittedFields, assignedUpfCourseId, assignedNewCourseId, useUpfSchoolDefault, { data }) =>
    ({ type: CHANGE_COURSE_SUCCESS, classroomId, groupId, assignedCourseId, submittedFields, assignedUpfCourseId, assignedNewCourseId, useUpfSchoolDefault, data });

export const changeCourseFailure = () =>
    ({ type: CHANGE_COURSE_FAILURE, isChangingCourseInProgress: false, refreshEditClass: false });

export const CHANGE_COURSE_CARRY_OVER_REQUEST = 'CHANGE_COURSE_CARRY_OVER_REQUEST';
export const CHANGE_COURSE_CARRY_OVER_SUCCESS = 'CHANGE_COURSE_CARRY_OVER_SUCCESS';
export const CHANGE_COURSE_CARRY_OVER_FAILURE = 'CHANGE_COURSE_CARRY_OVER_FAILURE';

export const changeCourseCarryOver = ({ changeCourseClassroomId, changeCourseGroupId, assignedCourseId, assignedUpfCourseId, isCarryOver, changeCourseAssignedTasks, assignedNewCourseId }) => {
    const taskActionType = isCarryOver ? CARRY_OVER_TASK_TYPE : CANCEL_TASK_TYPE;
    return ({
        type: CHANGE_COURSE_CARRY_OVER_REQUEST,
        classroomId: changeCourseClassroomId,
        groupId: changeCourseGroupId,
        newCourseId: assignedCourseId,
        newUpfCourseId: assignedUpfCourseId,
        newConquestCourseId: assignedNewCourseId,
        taskActionType,
        courses: changeCourseAssignedTasks });
};


export const changeCourseCarryOverSuccess = () =>
    ({ type: CHANGE_COURSE_CARRY_OVER_SUCCESS });

export const changeCourseCarryOverFailure = () =>
    ({ type: CHANGE_COURSE_CARRY_OVER_FAILURE, isChangingCourseInProgress: false, refreshEditClass: false });

export const OPEN_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT = 'OPEN_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT';
export const CLOSE_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT = 'CLOSE_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT';

export const openDeleteGroupConfirmationBeforeSubmit = () =>
    ({
        type: OPEN_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT,
        showDeleteGroupConfirmationBeforeSubmit: true
    });

export const closeDeleteGroupConfirmationBeforeSubmit = () =>
    ({
        type: CLOSE_DELETE_GROUP_CONFIRMATION_BEFORE_SUBMIT,
        showDeleteGroupConfirmationBeforeSubmit: false
    });

export const CLOSE_EDIT_CLASS = 'CLOSE_EDIT_CLASS';

export const closeEditClass = () => ({ type: CLOSE_EDIT_CLASS });

export const CLOSE_EDIT_GROUP = 'CLOSE_EDIT_GROUP';

export const closeEditGroup = () => ({ type: CLOSE_EDIT_GROUP });

export const OPEN_ADD_GROUP = 'OPEN_ADD_GROUP';
export const CLOSE_ADD_GROUP = 'CLOSE_ADD_GROUP';
export const ADD_GROUP_REQUEST = 'ADD_GROUP_REQUEST';
export const ADD_GROUP_SUCCESS = 'ADD_GROUP_SUCCESS';
export const ADD_GROUP_FAILURE = 'ADD_GROUP_FAILURE';

export const openAddGroup = () => ({
    type: OPEN_ADD_GROUP,
    addGroupIsActive: true
});

export const closeAddGroup = () => ({
    type: CLOSE_ADD_GROUP,
    addGroupIsActive: false
});

export const addGroup = (classroomId, name) => ({
    type: ADD_GROUP_REQUEST,
    classroomId,
    name
});

export const addGroupSuccess = ({ data }) => ({
    type: ADD_GROUP_SUCCESS,
    data
});

export const addGroupFailure = ({ code }) => ({
    type: ADD_GROUP_FAILURE,
    addGroupErrorCode: code
});

export const HANDLE_COUNTRY_DROPDOWN_CHANGES = 'HANDLE_COUNTRY_DROPDOWN_CHANGES';
export const handleCountryDropdownChanges = (field, value) =>
    ({
        type: HANDLE_COUNTRY_DROPDOWN_CHANGES,
        field,
        value
    });

export const GET_YEARGROUPS_BY_COUNTRY_SUCCESS = 'GET_YEARGROUPS_BY_COUNTRY_SUCCESS';
export const getYearGroupsByCountrySuccess = data =>
    ({
        type: GET_YEARGROUPS_BY_COUNTRY_SUCCESS,
        data
    });

export const GET_YEARGROUPS_BY_COUNTRY_FAILURE = 'GET_YEARGROUPS_BY_COUNTRY_FAILURE';
export const getYearGroupsByCountryFailure = () =>
    ({
        type: GET_YEARGROUPS_BY_COUNTRY_FAILURE
    });




// WEBPACK FOOTER //
// ./app/containers/edit-class/actions.js